var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-descriptions",
    { attrs: { title: "处方详情", column: 4, border: "" } },
    [
      _c("el-descriptions-item", { attrs: { span: 2, label: "名称" } }, [
        _vm._v(_vm._s(_vm.row.name) + " "),
      ]),
      _c("el-descriptions-item", { attrs: { span: 2, label: "方剂出处" } }, [
        _vm._v(_vm._s(_vm.row.prescriptionSource) + " "),
      ]),
      _c("el-descriptions-item", { attrs: { span: 4, label: "方剂内容" } }, [
        _vm._v(_vm._s(_vm.row.prescriptionContent) + " "),
      ]),
      _c("el-descriptions-item", { attrs: { span: 4, label: "方剂说明" } }, [
        _vm._v(_vm._s(_vm.row.prescriptionDescribe) + " "),
      ]),
      _c("el-descriptions-item", { attrs: { label: "用药天数" } }, [
        _vm._v(_vm._s(_vm.row.dayNum) + " "),
      ]),
      _c("el-descriptions-item", { attrs: { label: "每日剂数" } }, [
        _vm._v(_vm._s(_vm.row.dayDoseNum) + " "),
      ]),
      _c("el-descriptions-item", { attrs: { label: "每日次数" } }, [
        _vm._v(_vm._s(_vm.row.dayFreq) + " "),
      ]),
      _c("el-descriptions-item", { attrs: { label: "剂数" } }, [
        _vm._v(_vm._s(_vm.row.doseNum) + " "),
      ]),
      _c("el-descriptions-item", { attrs: { label: "代加工" } }, [
        _vm._v(_vm._s(_vm._f("DecoctSignType")(_vm.row.decoctSign)) + " "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }